import React, { useEffect } from 'react';
import LazyLoadComponent, {
  forceCheck as checkLazyLoadOnVisibilityChange,
} from 'react-lazyload';

import { LazyLoadProps } from './LazyLoad.types';

//Todo manage customStyleProp
const LazyLoad = ({
  loadOnce,
  placeholder,
  style,
  render,
  offset,
  height,
  children,
  componentClassname = 'lazyload',
  customClassnames = '',
  ...props
}: LazyLoadProps) => {
  useEffect(() => {
    // Used for components such as overlay etc. those are not dependent on scroll behaviour
    checkLazyLoadOnVisibilityChange();
  }, [props]);

  return (
    <LazyLoadComponent
      className={`${componentClassname} ${customClassnames}`}
      offset={offset || 100}
      once={`${loadOnce}` !== 'false'}
      style={style}
      height={height || '100%'}
      placeholder={placeholder}
    >
      {render || children}
    </LazyLoadComponent>
  );
};
LazyLoad.displayName = 'LazyLoad';

export default LazyLoad;
